<ion-grid>
  <ion-row>
    <ion-col class="add-label">
      Add exercise
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="4">
      <ion-button fill="outline" expand="block" id="open-modal">
        <ion-icon slot="start" name="create-outline"></ion-icon>
        New
      </ion-button>
    </ion-col>
    <ion-col size="4">
      <ion-button fill="outline" expand="block" id="open-from-db">
        <ion-icon slot="start" name="add-circle-outline"></ion-icon>
        Existing
      </ion-button>
    </ion-col>
    <ion-col size="4">
      <ion-button fill="outline" expand="block" id="open-modalAddExisting">
        <ion-icon slot="start" name="add-circle-outline"></ion-icon>
        Library
      </ion-button>
    </ion-col>
  </ion-row>
</ion-grid>

<ion-modal trigger="open-from-db" [presentingElement]="presentingElement">
  <ng-template>
    <ion-content>
      <app-exercise-from-db (exerciseAdded)="exerciseAdded.emit($event); updateS()"></app-exercise-from-db>
    </ion-content>
  </ng-template>
</ion-modal>

<ion-modal #modal trigger="open-modal" [presentingElement]="presentingElement">
  <ng-template>
    <ion-content>
      <app-add-exercise
        (closeView)="modal.dismiss()"
        (exerciseAdded)="exerciseAdded.emit($event); updateS()"
      ></app-add-exercise>
    </ion-content>
  </ng-template>
</ion-modal>

<ion-modal
  #modalAddExisting
  trigger="open-modalAddExisting"
  [presentingElement]="presentingElement"
>
  <ng-template>
    <ion-content>
      <app-add-existing
        (exercisesEmitted)="exercisesEmitted.emit($event); updateS()"
        (closeView)="modalAddExisting.dismiss()"
        (noExercise)="modal.present()"
      ></app-add-existing>
    </ion-content>
  </ng-template>
</ion-modal>
